export default "__VITE_ASSET__CfUPwAGw__"